// Registry linking the page-level "Skip to code editor" control to the editable Monaco panel on the page
import { useSyncExternalStore } from 'react'

let target = null
const listeners = new Set()

const notify = () => listeners.forEach(listener => listener())

export const registerSkipToEditorTarget = focus => {
    target = focus
    notify()
    return () => {
        if (target === focus) {
            target = null
            notify()
        }
    }
}

const subscribe = listener => {
    listeners.add(listener)
    return () => listeners.delete(listener)
}

export const useSkipToEditorTarget = () =>
    useSyncExternalStore(
        subscribe,
        () => target,
        () => null,
    )
